import { useEffect, useRef, useState } from "react";
import { openModal } from "risa-oasis-ui_v2";
import EmbedPDFModal from "../../../components/modals/embedPDFmodal/embedPDFmodal";
import { FinalWorklistDataResponse } from "../../../data-model/finalWorklistModel";
import { LocalStorageKeys } from "../../../enums/localStorageKeys";
import {
  getItemFromLocalStorage,
  setItemInLocalStorage,
} from "../../../utils/localStorageHelper";
import FinalWorklistOrdersTable from "./components/finalWorklistOrdersTable";

interface MedicalPaOrdersProps {
  onComplete?: boolean;
}

const FinalWorklist = (props: MedicalPaOrdersProps) => {
  const medicalPaOrdersTableRef = useRef<HTMLDivElement>(null);
  const [selectedOrderId, setSelectedOrderId] = useState<string>("");
  const [selectedRowData, setSelectedRowData] = useState<
    FinalWorklistDataResponse | undefined
  >(undefined);
  const [isViewLegacy, setIsViewLegacy] = useState(false);
  useEffect(() => {
    const storedViewLegacy = getItemFromLocalStorage(
      LocalStorageKeys.VIEW_LEGACY,
    );
    setIsViewLegacy(storedViewLegacy !== null ? storedViewLegacy : false);
  }, []);

  const [isPDFModalOpen, setIsPDFModalOpen] = useState(false);
  useEffect(() => {
    if (isPDFModalOpen) {
      openModal("embed-pdf-modal");
    }
  }, [isPDFModalOpen]);

  useEffect(() => {
    setItemInLocalStorage(
      LocalStorageKeys.PARENT_TABLE,
      window.location.pathname.split("/").slice(-1)[0],
    );
  }, []);

  return (
    <div
      className={`medical-pa-orders--main-container flex h-full flex-col overflow-hidden ${
        isViewLegacy ? "p-3" : ""
      }`}
    >
      <div className="medical-pa-orders__header mb-4 flex items-center justify-between text-h11 font-bold text-primaryGray-1">
        All PA Orders
      </div>

      <div className="medical-pa-orders__table-container flex-1 overflow-auto">
        <FinalWorklistOrdersTable
          medicalPaOrdersTableRef={medicalPaOrdersTableRef}
          onDataChange={() => {}}
          onComplete={false}
          onBulkAssignButtonClick={() => {}}
          onDownloadButtonClick={(
            id: string,
            rowData?: FinalWorklistDataResponse,
          ) => {
            setSelectedOrderId(rowData?.upload_id ?? "");
            setSelectedRowData(rowData);
            setIsPDFModalOpen(true);
          }}
        />
      </div>
      {isPDFModalOpen && (
        <EmbedPDFModal
          id={selectedOrderId}
          isModalOpen={isPDFModalOpen}
          onClose={() => setIsPDFModalOpen(false)}
          rowData={selectedRowData}
          uploadId={selectedOrderId}
        />
      )}
    </div>
  );
};

export default FinalWorklist;
